import { Record } from "immutable";

import createFromJS from "../../../createFromJS";
import { SizeRecord } from "../../helper/SizeRecord";
// import orientations from "../../../../constants/orientations";

export const NarrativeDropPositionRecord = Record({
  sourceParent: null,
  sourceIndex: null,
  targetParent: null,
  targetIndex: null,
  targetOrientation: null,
  draggedId: null,
  dropTargetId: null,
  dropAction: null,
  draggedSize: SizeRecord()
});

const data = {
  objects: {
    draggedSize: "SizeRecord"
  }
};
createFromJS.registerCallback(
  "NarrativeDropPositionRecord",
  createFromJS.createNestedCallback(NarrativeDropPositionRecord, data)
);
